<template>
  <section
    class="brief-welcome brief__step uk-cover-container uk-flex uk-flex-middle"
  >
    <picture>
      <source
        srcset="@/assets/images/misja-brief.png"
        media="(min-width: 960px)"
      />
      <source
        srcset="@/assets/images/misja-brief@tab.png"
        media="(min-width: 640px)"
      />
      <source srcset="@/assets/images/misja-brief@mob.png" />
      <img
        alt="powitania tło"
        src="@/assets/images/misja-brief.png"
        class="about-team__image"
        data-uk-cover
      />
    </picture>
    <div class="uk-container">
      <div class="brief-welcome__content">
        <h2 class="brief-welcome__header">
          misja brief
          <span class="page-section__title-tooltip">strony / sklepy</span>
        </h2>
        <p class="brief-welcome__description">
          zapraszamy w krótką podróż po pytaniach
        </p>
        <span class="brief-welcome__hash"> #nostress </span>
        <button
          class="button button--arrow button--shadow"
          @click="$emit('increment-step')"
        >
          start
        </button>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Welcome',
};
</script>
<style scoped lang="scss">
.brief-welcome {
  background-color: $purpleDim;
  color: $white;
  position: relative;
  min-height: 100vh;
  width: 100%;

  &__header {
    font-size: 1.75rem;
    font-weight: 900;
    margin-bottom: rem(40px);

    @include media-min($lg) {
      font-size: 2.5rem;
      margin-bottom: rem(48px);
    }
  }

  &__description {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: rem(40px);
    max-width: 12.625rem;

    @include media-min($sm) {
      max-width: unset;
    }
  }

  &__hash {
    font-size: 1.25rem;
    font-weight: 500;
    color: $teal;
    display: block;
    margin-bottom: rem(95px);
  }

  &__content {
    @include media-min($lg) {
      transform: translateY(rem(-70px));
    }
  }

  .uk-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: rem(800px);
  }

  .page-section__title-tooltip {
    color: #000;
  }
}
</style>
